import type { HelpContent } from './types'
import { LEADS_HELP } from './content/leads'
import { LEAD_DISCOVERY_HELP } from './content/lead-discovery'
import { DASHBOARD_HELP } from './content/dashboard'
import { CONTENT_HELP } from './content/content'
import { INBOX_HELP } from './content/inbox'
import { SETTINGS_HELP } from './content/settings'
import { CAMPAIGNS_HELP } from './content/campaigns'

/**
 * Maps a section key to its Help panel + walkthrough content. Adding guidance
 * for a new section is a one-line entry here plus a new `content/<key>.ts`
 * module; nothing else in the help system needs to change.
 */
const REGISTRY: Readonly<Record<string, HelpContent>> = {
  [LEADS_HELP.key]: LEADS_HELP,
  [LEAD_DISCOVERY_HELP.key]: LEAD_DISCOVERY_HELP,
  [DASHBOARD_HELP.key]: DASHBOARD_HELP,
  [CONTENT_HELP.key]: CONTENT_HELP,
  [INBOX_HELP.key]: INBOX_HELP,
  [SETTINGS_HELP.key]: SETTINGS_HELP,
  [CAMPAIGNS_HELP.key]: CAMPAIGNS_HELP,
}

export function getHelpContent(key: string): HelpContent | null {
  return REGISTRY[key] ?? null
}

export type { HelpContent } from './types'
